/**
 * Constants related to the Service Worker used by Web Register.
 */
const SERVICE_WORKER = {
  /**
   * The name of the Service Worker file.
   *
   * @property SERVICE_WORKER.MAIN_FILE
   * @type {String}
   */
  MAIN_FILE: 'vend-service-worker.js',
  /**
   * The name of the Service Worker registration file.
   *
   * @property SERVICE_WORKER.REGISTRATION_FILE
   * @type {String}
   */
  REGISTRATION_FILE: 'sw-registration.js',
  /**
   * The name of the Service Worker cache file.
   *
   * @property SERVICE_WORKER.STATIC_CACHE_FILE
   * @type {String}
   */
  STATIC_CACHE_FILE: 'service-worker-static-cache.json',
  /**
   * The name of the Service Worker file cache template.
   *
   * @property SERVICE_WORKER.STATIC_CACHE_TPL
   * @type {String}
   */
  STATIC_CACHE_TPL: 'service-worker-static-cache.tpl',
  /**
   * The name of the Service Worker cache file.
   *
   * @static
   * @property SERVICE_WORKER.STATIC_CACHE_PREFIX
   * @type {String}
   */
  STATIC_CACHE_PREFIX: 'webregister-static-cache-',
  /**
   * The name of the static caches cache that stores each static cache file. There is currently only one static cache
   * (service-worker-static-cache.json) for Web Register. Other apps can add their own static cache for offline support.
   *
   * @static
   * @property SERVICE_WORKER.STATIC_CACHES_CACHE
   * @type {String}
   */
  STATIC_CACHES_CACHE: 'vend-static-caches',

  /**
   * The location of the import map responsible for mapping bare specifiers to URLs
   *
   * @static
   * @property SERVICE_WORKER.IMPORT_MAP_URL
   * @type {String}
   */
  IMPORT_MAP_URL: '/import-map.json',

  /**
   * Specifier for the navigation module
   *
   * @static
   * @property SERVICE_WORKER.NAVIGATION_SPECIFIER
   * @type {String}
   */
  NAVIGATION_SPECIFIER: '@vend-spa/navigation',

  /**
   * Specifier for the navigation css
   *
   * @static
   * @property SERVICE_WORKER.NAVIGATION_CSS_SPECIFIER
   * @type {String}
   */
  NAVIGATION_CSS_SPECIFIER: '@vend-spa/navigation-css',

  /**
   * Bare specifiers for additional modules loaded by the navigation
   *
   * @static
   * @property SERVICE_WORKER.ADDITIONAL_NAV_SPECIFIERS
   * @type {Array<String>}
   */
  ADDITIONAL_NAV_SPECIFIERS: ['react', 'react-dom'],

  /**
   * URLs for the SystemJS bundles required by the navigation
   *
   * @static
   * @property SERVICE_WORKER.SYSTEM_JS_URLS
   * @type {Array<String>}
   */
  SYSTEM_JS_URLS: [
    'https://vendappcdn.freetls.fastly.net/packages/shared/static/system/js/systemjs.6.14.1-0.1.0.js',
  ],

  /**
   * Tests to identify if a URL is part of the navigation
   *
   * @static
   * @property SERVICE_WORKER.NAV_TEST
   * @type {Array<String>}
   */
  NAV_TEST: [/cdn\.jsdelivr\.net\/npm\//, /nav\.[0-9]+\.js/],
}

/**
 * Constants related to the Service Worker events emitted during it's lifecycle.
 */
const SERVICE_WORKER_EVENTS = {
  /**
   * Used to identify that the Service Worker has been updated.
   *
   * @static
   * @property SERVICE_WORKER_EVENTS.SERVICE_WORKER_UPDATED
   * @type {String}
   */
  SERVICE_WORKER_UPDATED: 'SERVICE_WORKER_UPDATED',
  /**
   * Used to identify that the Service Worker has been installed.
   *
   * @static
   * @property SERVICE_WORKER_EVENTS.SERVICE_WORKER_INSTALLED
   * @type {String}
   */
  SERVICE_WORKER_INSTALLED: 'SERVICE_WORKER_INSTALLED',
  /**
   * Used to request that Service Worker caches should be updated.
   *
   * @static
   * @property SERVICE_WORKER_EVENTS.UPDATE_CACHES
   * @type {String}
   */
  UPDATE_CACHES: 'UPDATE_CACHES',
  /**
   * Used to request that Service Worker and it's caches should be updated.
   *
   * @static
   * @property SERVICE_WORKER_EVENTS.UPDATE_ALL
   * @type {String}
   */
  UPDATE_ALL: 'UPDATE_ALL',
}

export { SERVICE_WORKER, SERVICE_WORKER_EVENTS }
